"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var core_1 = require("@material-ui/core");
var classnames_1 = __importDefault(require("classnames"));
exports.default = react_1.forwardRef(function Grid(_a, ref) {
    var _b;
    var className = _a.className, item = _a.item, _c = _a.grow, grow = _c === void 0 ? false : _c, props = __rest(_a, ["className", "item", "grow"]);
    var classes = useStyles();
    return (jsx_runtime_1.jsx(Grid_1.default, __assign({ item: item, className: classnames_1.default(className, (_b = {},
            _b[classes.flexGrow] = item && grow,
            _b)) }, props, { ref: ref }), void 0));
});
var useStyles = core_1.makeStyles({
    flexGrow: {
        flexGrow: 1,
    },
});
//# sourceMappingURL=Grid.js.map